'use client';

import React, { SVGProps, useMemo } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { Element } from '@/types/models';
import { Arrow, ArrowLeft, ArrowtriangleLeft, ArrowtriangleLeftBlack, BlogMenu, BlueConnection, BuildingOffice, CardNumbers, CheckPolygon, CheckShieldFilled, CheckShieldOutlined, CheckCircle, CheckmarkCircle, CircleCheckFiled, Copy, Documents, Download, Edit, EmptyState, EvaluationItem, EvaluationSend, Evaluation, FolderFileTick, Fundraiser, Gift, GrayConnection, GreenConnection, Guarantee, Headphone, History, Home, Hourglass, Industrial, Info, InvestAmount, InvestPayment, Invest, InvestMenu, Investable, Investor, Link, Location, Logout, Member, MessageBaloonsAccent, MoneyPaperDownload, MoneyReceive, MoneySend, Noti, OnlinePayment, Papers, Partnership, Percent, Phone, PhoneRing, PlanDeposit, PlanInvest, PlanNumber, PlansMenu, Profile, ProfileMenu, ProfileV2, Profit, ProfitV2, Receipt, ReceiptPayment, RocketFill, RocketOutlineFinish, RocketOutlineNotFinish, SuccessCheck, Target, Trash, UserReports, UserSupport, UserTransactions, UserChecked, VerifiedCheck, Plan, Investors, TotalIncome, TotalInvestor, TotalProfit, ClearInvest, EasyAccess, LowRisk, NewIdea, SocialProfitEffect, InvestBond, Compare, Sejam, Signup, Otp, NotVerified, Warning, NotificationBannerWarning, AuthorizeDone, Sync, PersonPlus, RegisterForm, Password, Questionnaire, Empty, DocCheckDone, Award, Trophy } from '@/components/svg-icons';
import { cn } from '@/utils/function';
export const IconsMap = {
  Arrow,
  ArrowLeft,
  ArrowtriangleLeft,
  ArrowtriangleLeftBlack,
  BlogMenu,
  BlueConnection,
  BuildingOffice,
  CardNumbers,
  CheckPolygon,
  CheckShieldFilled,
  CheckShieldOutlined,
  CheckCircle,
  CheckmarkCircle,
  CircleCheckFiled,
  Copy,
  Documents,
  Download,
  Edit,
  EmptyState,
  EvaluationItem,
  EvaluationSend,
  Evaluation,
  FolderFileTick,
  Fundraiser,
  Gift,
  GrayConnection,
  GreenConnection,
  Guarantee,
  Headphone,
  History,
  Home,
  Hourglass,
  Industrial,
  Info,
  InvestAmount,
  InvestPayment,
  Invest,
  InvestMenu,
  Investable,
  Investor,
  Link,
  Location,
  Logout,
  Member,
  MessageBaloonsAccent,
  MoneyPaperDownload,
  MoneyReceive,
  MoneySend,
  Noti,
  OnlinePayment,
  Papers,
  Partnership,
  Percent,
  Phone,
  PhoneRing,
  PlanDeposit,
  PlanInvest,
  PlanNumber,
  Plan,
  PlansMenu,
  Profile,
  ProfileMenu,
  ProfileV2,
  Profit,
  ProfitV2,
  Receipt,
  ReceiptPayment,
  RocketFill,
  RocketOutlineFinish,
  RocketOutlineNotFinish,
  SuccessCheck,
  Target,
  Trash,
  UserReports,
  UserSupport,
  UserTransactions,
  UserChecked,
  VerifiedCheck,
  Investors,
  TotalIncome,
  TotalInvestor,
  TotalProfit,
  ClearInvest,
  LowRisk,
  NewIdea,
  EasyAccess,
  SocialProfitEffect,
  InvestBond,
  Compare,
  Sejam,
  Signup,
  Otp,
  NotVerified,
  Warning,
  NotificationBannerWarning,
  AuthorizeDone,
  Sync,
  RegisterForm,
  Password,
  Questionnaire,
  Empty,
  DocCheckDone,
  PersonPlus,
  Award,
  Trophy
};
export type IconType = keyof typeof IconsMap;
export const IconSvg = ({
  component,
  className = '',
  fill = 'none',
  ...props
}: {
  component: IconType;
  className?: string;
  fill?: string;
} & SVGProps<SVGSVGElement>): Element => {
  const Component = useMemo(() => IconsMap[component], [component]);
  return <Component className={cn('', className)} {...props} fill={fill} data-sentry-element="Component" data-sentry-component="IconSvg" data-sentry-source-file="Icon.tsx" />;
};
interface SvgIconWrapperProps extends Omit<SvgIconProps, 'component'> {
  component: IconType;
}
const SvgIconWrapper: React.FC<SvgIconWrapperProps> = ({
  component,
  ...props
}) => {
  const Component = useMemo(() => IconsMap[component], [component]);
  return <SvgIcon component={Component} {...props} data-sentry-element="SvgIcon" data-sentry-component="SvgIconWrapper" data-sentry-source-file="Icon.tsx" />;
};
export default SvgIconWrapper;